// Toggle global por si hay que revertir rápido (no usar env, constante local)
export const ENABLE_CREATOR_FALLBACK = true;

// Heurística conservadora: € por cada 1.000 followers / mes
// (muy simple a propósito, para no romper nada)
const IG_EUR_PER_1K_PER_MONTH = 25; // conservador
const TT_EUR_PER_1K_PER_MONTH = 20; // conservador
const MIN_ANNUAL_FLOOR = 3000;      // si hay señales, mínimo prudente
const MAX_ANNUAL_CAP  = 120000;     // techo para outliers

export function estimateAnnualForCreator(signals) {
  const ig = Math.max(0, Number(signals.instagramFollowers) || 0);
  const tt = Math.max(0, Number(signals.tiktokFollowers) || 0);

  // si no hay señal real, no estimamos
  const hasSignal = ig >= 5000 || tt >= 10000;
  if (!hasSignal) return 0;

  const monthly =
    (ig / 1000) * IG_EUR_PER_1K_PER_MONTH +
    (tt / 1000) * TT_EUR_PER_1K_PER_MONTH;

  const annual = Math.round(monthly * 12);
  return Math.max(MIN_ANNUAL_FLOOR, Math.min(annual, MAX_ANNUAL_CAP));
}